import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class GetKamDailyReportPreviewsResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                "reports": [{
                    "recipient_name": "Michael Scott",
                    "recipient_email": "michael@dundermifflin.com",
                    "blocked_customers_count": 1,
                    "at_risk_customers_count": 0,
                    "total_overdue": {"amount": 1234567.89, "currency": "ARS"},
                    "blocked_customers": [{
                        "business_name": "Client123BN123",
                        "fantasy_name": "Client123",
                        "worst_tier": {"code": "8_to_15", "label": "+7 a 15"},
                        "is_high_risk": false,
                        "has_order_with_future_delivery": false,
                        "overdue_balance": {"amount": 1234567.89, "currency": "ARS"}
                    }],
                    "at_risk_customers": [],
                    "email": {
                        "sender": "no-reply@sapore-di-pane.com.ar",
                        "subject": "Clientes bloqueados por mora — 17/09/2026",
                        "html_content": "<html><body><p>Hola Michael Scott,</p></body></html>"
                    },
                    "teams": {
                        "summary": "🔒 Clientes bloqueados por mora — 17/09/2026",
                        "card": {
                            "$schema": "http://adaptivecards.io/schemas/adaptive-card.json",
                            "type": "AdaptiveCard",
                            "version": "1.4",
                            "body": [
                                {"type": "TextBlock", "text": "🔒 Clientes bloqueados por mora — 17/09/2026",
                                 "weight": "Bolder", "size": "Large", "wrap": true},
                                {"type": "TextBlock", "text": "Hola Michael Scott, te paso el resumen de hoy:",
                                 "wrap": true, "isSubtle": true, "spacing": "Small"},
                                {"type": "FactSet", "spacing": "Medium", "facts": [
                                    {"title": "🔒 Bloqueados (8+ días):", "value": "1 — Client123"},
                                    {"title": "⚠️ Riesgo de bloqueo (0 a 7 días):", "value": "Sin clientes en riesgo de bloqueo hoy"},
                                    {"title": "Total vencido:", "value": "$ 1.234.567,89"}
                                ]},
                                {"type": "TextBlock",
                                 "text": "⚠️ Alto riesgo: se bloquea con cualquier mora, sin ampliación de crédito; se incluye en Bloqueados si tiene deuda vencida.",
                                 "wrap": true, "isSubtle": true, "spacing": "Medium"},
                                {"type": "TextBlock", "text": "Detalle completo por mail. 🙌",
                                 "wrap": true, "isSubtle": true, "spacing": "Medium"}
                            ]
                        }
                    }
                }]
            },
            errors: []
        }
    }

    reports() {
        return this.content().reports.map(report => this._reportPreviewOf(report));
    }

    _reportPreviewOf(report) {
        return {
            recipientName: report.recipient_name,
            recipientEmail: report.recipient_email,
            recipientLabel: this._recipientLabelOf(report.recipient_name, report.recipient_email),
            blockedCustomersCount: report.blocked_customers_count,
            atRiskCustomersCount: report.at_risk_customers_count,
            totalOverdue: report.total_overdue,
            email: {
                sender: report.email.sender,
                subject: report.email.subject,
                htmlContent: report.email.html_content,
            },
            teams: this._teamsPreviewOf(report.teams),
        };
    }

    _recipientLabelOf(recipientName, recipientEmail) {
        if (recipientName) {
            return `${recipientName} (${recipientEmail})`;
        }
        return recipientEmail;
    }

    _teamsPreviewOf(teams) {
        const cardBodyBlocks = teams.card.body;
        const introBlock = cardBodyBlocks.find(block => block.type === 'TextBlock' && block.spacing === 'Small');
        const factSetBlock = cardBodyBlocks.find(block => block.type === 'FactSet');
        const noteBlocks = cardBodyBlocks.filter(block => block.type === 'TextBlock' && block.spacing === 'Medium');
        return {
            title: teams.summary,
            intro: introBlock ? introBlock.text : '',
            facts: factSetBlock ? factSetBlock.facts.map(fact => ({label: fact.title.replace(/:$/, ''), value: fact.value})) : [],
            notes: noteBlocks.map(noteBlock => noteBlock.text),
        };
    }

}
